const keycloak =
  process.env.NODE_ENV === "test"
    ? {}
    : JSON.parse(process.env.REACT_APP_BACKEND_KEYCLOAK);

// eslint-disable
export { keycloak };
